import { SessionStorageKeys, SignupType, UserRoles } from '@constants';
import TourSelectionGate from '@components/TourSelectionGate';
import { isPaymentsCompany } from '@utils/helpers';
import { isEmpty } from 'ramda';
import React from 'react';
import { Redirect, Route } from 'react-router';

function checkOnboardingFlow(user, path) {
  // `user.profile` is not guaranteed. /api/v1/user/me answers 200 with only
  // `{ userIp }` for a few referrers (REFERRERS_TO_SKIP in the backend's
  // authentication middleware), and an account left half-removed can come back
  // without a profile too. `isEmpty(user)` is false in both cases, so we reach
  // here — and on React 16 a TypeError during render unmounts the whole tree,
  // which is a white page with no way back to the sign-in screen.
  const hasIncompleteOnboardingSteps =
    user.profile?.onboarding?.tipping == false || user.profile?.onboarding?.profile == false;
  const interestedInTapToTip = user.profile?.interestedIn === SignupType.TapToTip;
  const isNotOnboardingPage = path !== '/onboarding';
  //Note: Never interrupt with the user payout flow
  const isNotPayoutPage = path !== '/payoutlink' && path !== '/payoutlink-confirm';
  const skipAllSteps = sessionStorage.getItem(SessionStorageKeys.SkipAllSteps);

  if (
    hasIncompleteOnboardingSteps &&
    interestedInTapToTip &&
    isNotOnboardingPage &&
    isNotPayoutPage &&
    !skipAllSteps
  ) {
    return <Redirect to="/onboarding" />;
  }

  return null;
}
function checkRegion(user, props) {
  const envRegion = (process.env.REGION || '').toLowerCase();
  const userRegion = (user.region || '').toLowerCase();

  if (userRegion && userRegion !== envRegion) {
    // Allow "local" interop
    if (userRegion === 'local' || envRegion === 'local') return true;
    // QA server ignores region
    if (envRegion === 'qa') return true;

    logoutAndChangeRegion(
      userRegion,
      props.location.pathname + props.location.search + props.location.hash
    );
    return false;
  }

  return true;
}

function logoutAndChangeRegion(region, path) {
  // Guard: only redirect once per session/tab
  if (sessionStorage.getItem('regionRedirected') === '1') {
    return;
  }
  sessionStorage.setItem('regionRedirected', '1');

  // Delete the connect.sid cookie before redirecting
  document.cookie = 'connect.sid=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

  const next = new URL(window.location.href);
  next.pathname = path || '/';

  if (region === 'qa') {
    next.host = 'qats.tripadmit.com';
    next.protocol = 'https:';
    window.location.href = next.toString();
    return;
  }

  if (region === 'local') {
    next.host = 'localhost:3001';
    next.protocol = 'http:';
    window.location.href = next.toString();
    return;
  }

  next.host = `${region}.tip.direct`;
  next.protocol = 'https:';
  window.location.href = next.toString();
}


export function PrivateRoute({ user, adminOnly, paymentsCompanyOnly, ...props }) {
  if (isEmpty(user)) {
    return <Redirect to="/signin" />;
  }

  const allowedPaths = ['/tipdirect/payments', '/tipdirect/stripe'];
  if (user.role === UserRoles.paymentsAnalyst && props.path && !allowedPaths.includes(props.path)) {
    return <Redirect to="/tipdirect/payments" />;
  }

  if (adminOnly && user.role !== UserRoles.admin && user.role !== UserRoles.paymentsAnalyst) {
    return <Redirect to="/" />;
  }

  if (paymentsCompanyOnly && !isPaymentsCompany(user.companyId, user)) {
    return <Redirect to="/" />;
  }

  if (!checkRegion(user, props)) return null;

  const onboardingRedirect = checkOnboardingFlow(user, props.path);

  if (onboardingRedirect) return onboardingRedirect;

  return (
    <TourSelectionGate user={user} path={props.path}>
      <Route {...props} />
    </TourSelectionGate>
  );
}

export function TSUserRoute({ user, ...props }) {
  if (isEmpty(user)) {
    return <Redirect to="/tipdirect" />;
  }

  if (user.role === UserRoles.paymentsAnalyst) {
    return <Redirect to="/tipdirect/payments" />;
  }

  if (!checkRegion(user, props)) return null;

  const onboardingRedirect = checkOnboardingFlow(user, props.path);

  if (onboardingRedirect) return onboardingRedirect;

  return (
    <TourSelectionGate user={user} path={props.path}>
      <Route {...props} />
    </TourSelectionGate>
  );
}
